import React, { useContext, useEffect, useState } from 'react'
import MUIDataTable from "mui-datatables";
import styled from '@emotion/styled';
import ProfileContext from '../../../context/ProfileContext';
import { CacheProvider } from "@emotion/react";
import createCache from "@emotion/cache";
import useAuth from '../../../hooks/useAuth';
import useAxiosPrivate from "../../../hooks/useAxiosPrivate";
const muiCache = createCache({
	"key": "mui",
	"prepend": true
});


const StyledMUIDataTable=styled(MUIDataTable)(({theme})=>({
  background:theme.palette.background.default,
  //     '& .css-1nrlq1o-MuiFormControl-root':{
  //      padding:'16px 24px',
  // },
  // '& .css-1w1rijm-MuiButtonBase-root-MuiButton-root':{
  //   padding:'0px'
  // },
  // '& .css-nfmglb-MuiTableCell-root':{
  //   padding:'0px'
  // },
  //  '& .tss-1vsygk-MUIDataTableFilterList-root':{
  //   gap:'8px',
  //   marginBottom:'5px'

  // },
}))
export default function PartTimeTables(props) {
  const {changed}=useAuth();
  const api=useAxiosPrivate()
  const [data,setData]=useState([])
   useEffect(()=>{
      let isMounted=true;
      const controller=new AbortController();
      const getData=async ()=>{
        try{
          const response=await api.get(`request/listOffice/Part-Time`,{
            signal:controller.signal
          })
          isMounted &&  setData(response.data)}
        catch(err){
          console.error(err)
        }
      }
      getData();
      return ()=>{
        isMounted=false;
        controller.abort()
      }
        },[changed])
  const {state}=useContext(ProfileContext);
  const {calendar}=state
  const {year, semester}=calendar
  const columns = [
{
  name: "id",
  label: "ID",
  options: {
   filter: true,
   sort: true,
   display:false,
   filterList: props.id!==false? [props.id] : null,
  }
 },
   {
  name: "email",
  label: "Instructor Email",
  options: {
   filter: false,
   sort: true,
   display:false
  }
 },
 {
  name: "name",
  label: "Instructor Name",
  options: {
   filter: true,
   sort: true,
  }
 },
 {
  name: "date",
  label: "Date",
  options: {
   filter: true,
   sort: true,
  }
 },
 {
  name: "year",
  label: "Academic Year",
  options: {
   filter: true,
   sort: true,
  filterList: [year],

  }
 },
 {
   name: "semester",
   label: "Semester Term",
   options: {
     filter: true,
     sort: true,
    filterList: [semester],

     }
   },
  {
  name: "duration",
  label: "Semester Duration",
  options: {
   filter: true,
   sort: true,
  }
 },
  {
 name: "status",
 label: "Agreement Status",
 options: {
  filter: true,
  sort: true,
  filterList: props.id!==false?null:['Unsigned'],

 }
},
]
 return(
  <CacheProvider value={muiCache}>
  <StyledMUIDataTable
  title={props.title}
  data={data}
  columns={columns}
  options={props.option}
/></CacheProvider>
 )} 